import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useIsLoggedIn } from 'hooks/use-is-logged-in';
import { UseQueryOptions, UseQueryResult } from 'react-query';
import { CreditUtilizationDto } from './use-get-credit-utilizations-api';

const endpoint = 'ums/v1/cms/bnpl/credit-utilizations';
export const getCreditUtilizationEndpointIdentifier = endpoint;

interface ResponseData {
  data: CreditUtilizationDto;
}

type TData = ResponseData;
type TError = AxiosError;
type TQueryKey = [string, number | string];
type Options = Omit<UseQueryOptions<unknown, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

export function useGetCreditUtilizationApi(utilizationId: number | string, options?: Options): ReturnType {
  const toast = useCustomToast();
  const isLoggedIn = useIsLoggedIn();

  const queryFn = async () => {
    try {
      const { data } = await http.get(`${endpoint}/${utilizationId}`);
      return data;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;
      toast({ description: error.response.data.message, status: 'error' });
      throw error;
    }
  };

  return useQueryWrapper([`${endpoint}/detail`, utilizationId], queryFn, {
    enabled: isLoggedIn && !!utilizationId,
    ...options,
  });
}
